import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Invoices from './Invoices';
import Artists from './Artists';
import Services from './Services';
import Inspiration from './Inspiration';


@inject('userStore')
@withRouter
@observer
class Event extends Component {
    constructor(props){
        super(props);
    }

    render() {
        const {event, modalHandler, saveInspiration} = this.props;
        // const {event} = this.state;

        return (
            <div className="row">
              <div className="col-lg-12">
                <div className="card card-shadowed">
                    <div className="media bb-1 border-fade">
                        <img className="avatar avatar-lg" src={event.business.thumb} alt={event.business.name}/>
                        <div className="media-body">
                            <p>
                                <strong className="fs-14">{event.business.name}</strong>
                            </p>
                            <p><small>{event.business.phone_primary} - <a href={"mailto:" + event.business.contact_email}>{event.business.contact_email}</a></small></p>
                        </div>
                    </div>
                  <div className="card-body">
                      <ul className="flexbox flex-justified">
                          <li className="br-1 border-light">
                              <div className="media media-single">
                                <i className="fs-30 fa fa-calendar"></i>
                                <div className="media-body">
                                  <div className="fs-18" style={{lineHeight:16+"px"}}>{event.date}<br/><small>Event Date</small></div>
                                </div>
                               </div>
                          </li>
                          <li className="br-1 border-light">
                              <div className="media media-single">
                                <i className="fs-30 fa fa-clock-o"></i>
                                <div className="media-body">
                                  <div className="fs-18" style={{lineHeight:16+"px"}}>{event.ready_time}<br/><small>Ready Time</small></div>

                                </div>
                               </div>
                          </li>
                          <li>
                              <div className="media media-single">
                                  <i className="fs-30 fa fa-map-marker"></i>
                                  <div className="media-body">
                                      <div className="fs-18" style={{lineHeight:16+"px"}}>{event.location_name}<br/><small>Ready Location</small></div>
                                  </div>
                              </div>
                          </li>
                      </ul>
                      <div className="row pt-30">
                          <div className="col-md-12 col-lg-9">
                              <Invoices invoices={event.invoice_list} event={event} modalHandler={modalHandler}/>
                              <Inspiration event={event} inspiration_list={event.inspiration_list} modalHandler={modalHandler} saveInspiration={saveInspiration}/>
                              <Services event={event} service_list={event.service_list} participant_list={event.participant_list}/>
                          </div>
                          <div className="col-md-12 col-lg-3">
                              <Artists artist_list={event.artist_list}/>
                              <div className="card card-outline-secondary">
                                  <div className="card-body">
                                      <div className="flexbox align-items-baseline">
                                          <h6 className="text-uppercase ls-2"><i className="fa fa-file-pdf-o"></i> Documents</h6>
                                      </div>
                                      <div className="media-list">
                                      {event.document_list.length === 0 ? <span className="badge badge-info">Published Documents will appear here</span> :event.document_list.map((document, index) =>
                                        <div className="media media-single" key={index}>
                                            <i className="fa fa-file-pdf-o fs-30"></i>
                                            <a href={document.document.document_url} target="_blank">
                                              <span>{document.sys_doc_type_id === 5 ? document.name : document.sys_doc_type}</span>
                                            </a>
                                        </div>
                                      )}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
    );}
}


export default Event;



// WEBPACK FOOTER //
// ./src/components/client/Event.js